var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "#2F2B3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49657 7C9.09985 7 8.71934 7.15794 8.43864 7.43864C8.15819 7.71909 8 8.10159 8 8.49857V19.4758C8 19.8728 8.15819 20.2553 8.43864 20.5358C8.71934 20.8165 9.09985 20.9744 9.49657 20.9744H18.48C18.877 20.9744 19.2595 20.8165 19.5399 20.5358C19.8206 20.2553 19.9766 19.8728 19.9766 19.4758V8.49857C19.9766 8.10159 19.8206 7.71909 19.5399 7.43864C19.2595 7.15794 18.877 7 18.48 7H9.49657ZM9.49657 7.99904H18.48C18.6132 7.99904 18.7395 8.05144 18.8333 8.14526C18.9269 8.23883 18.9795 8.36508 18.9795 8.49857V19.4758C18.9795 19.6093 18.9269 19.7356 18.8333 19.8291C18.7397 19.923 18.6132 19.9754 18.48 19.9754H9.49657C9.36333 19.9754 9.23908 19.923 9.14526 19.8291C9.05169 19.7356 8.99905 19.6093 8.99905 19.4758V8.49857C8.99905 8.36508 9.05169 8.23883 9.14526 8.14526C9.23908 8.05144 9.36333 7.99904 9.49657 7.99904Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2417 10.4941C11.9685 10.4939 11.7432 10.7182 11.7422 10.9917C11.7422 11.2656 11.9675 11.4912 12.2412 11.4912H15.7349C16.0086 11.4912 16.2339 11.2659 16.2339 10.9919C16.2331 10.7185 16.0078 10.4939 15.7344 10.4941H12.2417Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2417 13.4873H12.2412C11.9675 13.4873 11.7422 13.7126 11.7422 13.9863V13.9873C11.7422 14.2613 11.9675 14.4863 12.2412 14.4863H15.7349C16.0086 14.4863 16.2339 14.2613 16.2339 13.9873V13.9863C16.2339 13.7126 16.0086 13.4873 15.7349 13.4873H15.7344H12.2417Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2417 16.4824H12.2412C11.9675 16.4824 11.7422 16.7077 11.7422 16.9814V16.9819C11.7432 17.2554 11.9685 17.4797 12.2417 17.4795H15.7344C16.0078 17.4797 16.2331 17.2554 16.2339 16.9819V16.9814C16.2339 16.7077 16.0086 16.4824 15.7349 16.4824H15.7344H12.2417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.8bcf9d32b0197963aee09a7fb90f4ad6.svg";
export { ForwardRef as ReactComponent };